import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog } from '@/components/ui/dialog';
import { useCartStore } from '@/features/cart/stores/cart-store';

interface CallButtonProps {
  phoneNumber?: string;
  className?: string;
}

export function CallButton({ className }: CallButtonProps) {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const itemCount = useCartStore((state) => state.itemCount);

  const handleButtonClick = () => {
    if (itemCount === 0) {
      setError('Your cart is empty. Add items before starting a call order.');
      return;
    }

    navigate('/checkout?action=call');
  };

  return (
    <>
      <Button
        onClick={handleButtonClick}
        className={`bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-semibold shadow-lg hover:shadow-xl transition-all ${className || ''}`}
        size="lg"
      >
        <Phone className="w-5 h-5 mr-2" />
        Checkout then Call
      </Button>

      <Dialog
        open={!!error}
        onClose={() => setError(null)}
        title="Notice"
        size="sm"
      >
        <p className="text-gray-700">{error}</p>
        <div className="mt-4 flex justify-end">
          <Button onClick={() => setError(null)} variant="outline" size="sm">
            OK
          </Button>
        </div>
      </Dialog>
    </>
  );
}
